define.alias("ember-power-select/components/power-select/search-message", "media/components/power-select/search-message");